import { render } from "./PrivateQualification.vue?vue&type=template&id=b727b088"
import script from "./PrivateQualification.vue?vue&type=script&lang=js"
export * from "./PrivateQualification.vue?vue&type=script&lang=js"

import exportComponent from "/home/metabrain/withyou/djvue/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__